export default __webpack_public_path__ + "static/media/a037-student-t3-s3-3.f86c84ff.svg";